import { instance as axios, setJwtToken } from "../../config/axiosInstance";

// ---------------------Dashboard-listing--------------------------
// export const dashboardGraphApi = async (data) => {
//   const endPoint = `admin-dashboard/dashboard-graph-detail` + "?" + new URLSearchParams({ ...data });
//   return await axios.get(endPoint, setJwtToken());
// };

export const dashboardApi = async (data) => {
  const endPoint = `/admin/dashboard` + '?' + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
